import React from 'react'
import PropTypes from 'prop-types'
import { ErrorBoundary } from 'react-error-boundary'
import * as Analytics from 'core/common/analytics'
import i18n from 'core/common/i18n'
import { Button } from 'core/components/Core'
import Result, { ResultActionArea } from 'core/components/Result'

const AppError = ({ children }) => {
  return (
    <ErrorBoundary
      FallbackComponent={({ error, resetErrorBoundary }) => {
        const { message } = error
        Analytics.catchEventApp({ message })
        return (
          <Result
            status="500"
            title={i18n.t('error.500.title')}
            subtitle={i18n.t('error.500.subtitle')}
          >
            <ResultActionArea hasLogout>
              <Button onClick={resetErrorBoundary} variant="contained" color="primary">
                {i18n.t('error.500.labelAction')}
              </Button>
            </ResultActionArea>
          </Result>
        )
      }}
    >
      {children}
    </ErrorBoundary>
  )
}

AppError.propTypes = {
  children: PropTypes.node.isRequired,
}

export default AppError
